import type { Selection } from '@iconik-io/uad';

import { selectionToSet } from './selection_to_set';

export function selectionToFirstStringItem(
  selectedKeys: Selection | undefined,
): string | undefined {
  const selectedIds = selectionToSet(selectedKeys);
  return selectedIds.values().next().value;
}
